/**
 * TopTractsCta.tsx — call-to-action that opens the ranked "Top tracts in view" slide-out
 * (T-222 / BEAD-0040 R2).
 *
 * Ricardo's revision replaced the always-docked ranked panel with this compact chip: it sits
 * where the panel anchored (top-right of the map, at tract zoom) and, when clicked, slides the
 * ranked list out of the side panel using the tract-detail idiom. Discoverable but out of the
 * way — a bordered card button matching the app's control surfaces.
 */
import { ListOrdered } from 'lucide-react'

export interface TopTractsCtaProps {
  onClick: () => void
}

export function TopTractsCta({ onClick }: TopTractsCtaProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="flex items-center gap-2 rounded-xl bg-card px-3 py-2 text-sm font-bold text-foreground
                 shadow-md border border-border hover:bg-accent/60 transition-colors
                 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
    >
      <ListOrdered className="h-4 w-4 text-primary" aria-hidden />
      Top tracts in view
    </button>
  )
}
